module.exports = __webpack_public_path__ + "static/media/arrow-service.b73d4d4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/arrow-service.svg
// module id = 634
// module chunks = 0